import { useState } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";
const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };

const IMG = {
  logo: "/images/logo.webp",
};

const sessionTypes = [
  {
    id: "weekly",
    name: "Weekly Dance Sessions",
    tag: "Ongoing programme",
    color: C.mint,
    soft: C.mintSoft,
    description: "A structured, progressive weekly programme that builds confidence, coordination and creativity over time.",
    details: [
      "30 to 45 minute sessions",
      "Structured and progressive curriculum",
      "Fun games, routines and mini disco",
      "Ideal for EYFS, KS1 and KS2",
    ],
    pricing: [
      { label: "Per hour", price: "£50", note: "save £30 per term" },
      { label: "Half term (7 weeks, 1hr/week)", price: "£300", note: "" },
    ],
  },
  {
    id: "enrichment",
    name: "Workshops and Enrichment Days",
    tag: "One-off or short block",
    color: C.yellow,
    soft: C.yellowSoft,
    description: "High-energy, themed sessions perfect for enrichment days, special events or curriculum celebrations.",
    details: [
      "Half day or full day available",
      "Themed sessions available",
      "Interactive and engaging",
      "Perfect for special events and celebrations",
    ],
    pricing: [
      { label: "1 hour", price: "£50", note: "" },
      { label: "Half day (3 hours)", price: "£120", note: "save £30" },
      { label: "Full day (6 hours)", price: "£250", note: "save £80" },
    ],
  },
];

const benefits = [
  { title: "Builds Confidence", desc: "Encourages self-belief and helps children feel proud of their achievements.", color: C.pink },
  { title: "Supports Development", desc: "Improves coordination, listening skills, memory and overall wellbeing.", color: C.mint },
  { title: "Inclusive for All", desc: "Sessions are designed to suit all abilities in a fun, no-pressure environment.", color: C.yellow },
  { title: "Supports Education", desc: "Physical development and wellbeing in line with early years and primary outcomes.", color: C.blue },
  { title: "Easy to Organise", desc: "We take care of everything, making it simple and stress-free for schools.", color: C.lilac },
];

const differentiators = [
  { title: "No pressure, just participation", desc: "Children are encouraged to join in at their own pace in a safe, supportive environment.", color: C.mint },
  { title: "Confidence-first approach", desc: "We focus on building self-belief and self-expression, not just teaching routines.", color: C.pink },
  { title: "Inclusive for all abilities", desc: "Every session is adapted so every child can take part, feel included and succeed.", color: C.blue },
  { title: "Play-based, engaging sessions", desc: "We use games, storytelling and imaginative play to keep children active and engaged.", color: C.yellow },
  { title: "Engages even the quietest children", desc: "We create a welcoming space that helps shy or reserved children come out of their shell.", color: C.lilac },
  { title: "Proven demand", desc: "Our weekly sessions have a loyal following and our half-term specials have sold out.", color: C.mint },
];

const RainbowHeading = ({ children, size = 28, tag = "h2" }) => {
  const s = {
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  };
  if (tag === "h1") return <h1 style={s}>{children}</h1>;
  if (tag === "h3") return <h3 style={s}>{children}</h3>;
  return <h2 style={s}>{children}</h2>;
};

const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Schools" ? C.blue : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Schools" ? C.blueSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 – 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>© 2026 The Funky Bunch Kent. All rights reserved.</div>
    </div>
  </footer>
);

export default function SchoolsPage() {
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Form state
  const [schoolName, setSchoolName] = useState("");
  const [contactName, setContactName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [sessionInterest, setSessionInterest] = useState("");
  const [yearGroups, setYearGroups] = useState("");
  const [approxChildren, setApproxChildren] = useState("");
  const [preferredDays, setPreferredDays] = useState("");
  const [notes, setNotes] = useState("");
  const [formError, setFormError] = useState("");

  const inputStyle = {
    width: "100%", padding: "11px 14px", borderRadius: 12,
    border: `1.5px solid ${C.blue}30`, fontSize: 14,
    outline: "none", background: C.cream, fontFamily: body,
    marginBottom: 10, color: C.ink,
  };

  const handleSubmit = async () => {
    if (!schoolName || !contactName || !email || !sessionInterest) {
      setFormError("Please fill in all required fields.");
      return;
    }
    setFormError("");
    setSubmitting(true);
    try {
      await fetch("/.netlify/functions/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "school",
          schoolName,
          name: contactName,
          role,
          email,
          phone,
          sessionInterest,
          yearGroups,
          approxChildren,
          preferredDays,
          notes,
        }),
      });
    } catch (err) {
      // Continue to success state regardless
    }
    setSubmitting(false);
    setSubmitted(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        button:hover { transform: scale(1.03); transition: transform 0.2s; }
        button:active { transform: scale(0.98); }
        input, select, textarea { font-family: 'Nunito', sans-serif; }
      `}</style>

      <Nav />

      {/* Hero */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, ${C.blueSoft} 100%)`,
        padding: "44px 24px 36px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 680, margin: "0 auto" }}>
          <div style={{
            display: "inline-block",
            background: C.blueSoft, border: `2px solid ${C.blue}40`,
            borderRadius: 50, padding: "5px 18px", marginBottom: 14,
            fontFamily: body, fontSize: 12, fontWeight: 700,
            color: C.blue, letterSpacing: 0.5,
          }}>
            Schools and Nurseries
          </div>
          <RainbowHeading size={32} tag="h1">Dance and Movement Workshops</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 16, color: C.ink + "99",
            lineHeight: 1.7, margin: "12px auto 0", maxWidth: 520,
          }}>
            Fun, energetic dance sessions for young children. We come to your school and take care of everything.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 24, flexWrap: "wrap" }}>
            <button
              onClick={() => { setShowForm(true); document.getElementById("enquire-section").scrollIntoView({ behavior: "smooth" }); }}
              style={{
                background: C.blue, color: "#fff", border: "none",
                padding: "14px 32px", borderRadius: 50,
                fontFamily: heading, fontWeight: 700, fontSize: 15,
                cursor: "pointer",
              }}
            >
              Enquire Now
            </button>
            <a href="mailto:thefunkybunchashford@gmail.com" style={{
              background: "transparent", color: C.ink,
              border: `2px solid ${C.ink}20`,
              padding: "14px 32px", borderRadius: 50,
              fontFamily: heading, fontWeight: 700, fontSize: 15,
              cursor: "pointer", textDecoration: "none",
            }}>
              Email Us
            </a>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section style={{ padding: "40px 24px 20px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22} tag="h2">Benefits for your school</RainbowHeading>
          <div style={{ height: 20 }} />
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", justifyContent: "center" }}>
            {benefits.map((b, i) => (
              <div key={i} style={{
                flex: "1 1 160px", maxWidth: 190,
                background: "#fff", borderRadius: 20,
                border: `2px solid ${b.color}30`,
                padding: "20px 16px", textAlign: "center",
              }}>
                <div style={{
                  width: 10, height: 10, borderRadius: "50%",
                  background: b.color, margin: "0 auto 10px",
                }} />
                <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 13, color: C.ink, marginBottom: 6 }}>{b.title}</div>
                <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.5 }}>{b.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What's on offer */}
      <section style={{ padding: "40px 24px 20px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22} tag="h2">What we offer</RainbowHeading>
          <div style={{ height: 20 }} />
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap", justifyContent: "center" }}>
            {sessionTypes.map((s, i) => (
              <div key={i} style={{
                flex: "1 1 300px", maxWidth: 420,
                background: "#fff", borderRadius: 24,
                border: `2px solid ${s.color}30`,
                padding: "28px 24px",
              }}>
                <div style={{
                  display: "inline-block",
                  background: s.soft, borderRadius: 50,
                  padding: "3px 14px", marginBottom: 12,
                  fontFamily: body, fontSize: 11, fontWeight: 700,
                  color: s.color,
                }}>{s.tag}</div>
                <div style={{ fontFamily: heading, fontWeight: 800, fontSize: 18, color: C.ink, marginBottom: 8 }}>{s.name}</div>
                <p style={{ fontFamily: body, fontSize: 13, color: C.ink + "88", lineHeight: 1.6, marginBottom: 16 }}>{s.description}</p>
                {s.details.map((d, di) => (
                  <div key={di} style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 6 }}>
                    <div style={{ width: 6, height: 6, borderRadius: "50%", background: s.color, flexShrink: 0, marginTop: 5 }} />
                    <span style={{ fontFamily: body, fontSize: 12.5, color: C.ink + "aa", lineHeight: 1.5 }}>{d}</span>
                  </div>
                ))}
                <div style={{
                  marginTop: 20, borderTop: `1.5px solid ${s.color}20`, paddingTop: 16,
                }}>
                  <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 12, color: C.ink + "66", marginBottom: 10, letterSpacing: 0.5 }}>PRICING</div>
                  {s.pricing.map((p, pi) => (
                    <div key={pi} style={{
                      display: "flex", justifyContent: "space-between",
                      alignItems: "baseline", marginBottom: 8,
                    }}>
                      <div>
                        <span style={{ fontFamily: body, fontSize: 13, color: C.ink + "88" }}>{p.label}</span>
                        {p.note && <span style={{ fontFamily: body, fontSize: 11, color: s.color, fontWeight: 700, marginLeft: 6 }}>{p.note}</span>}
                      </div>
                      <span style={{ fontFamily: heading, fontWeight: 800, fontSize: 18, color: C.ink }}>{p.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div style={{
            maxWidth: 600, margin: "20px auto 0",
            background: C.yellowSoft, borderRadius: 16,
            border: `2px solid ${C.yellow}40`,
            padding: "14px 20px", textAlign: "center",
          }}>
            <div style={{ fontFamily: body, fontSize: 13, color: C.ink + "99", lineHeight: 1.6 }}>
              All sessions held at your school. Minimum booking is 1 hour. Half-term pricing is based on a 7-week commitment. All prices include VAT.
            </div>
          </div>
        </div>
      </section>

      {/* What makes us different */}
      <section style={{ padding: "40px 24px 20px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22} tag="h2">What makes us different</RainbowHeading>
          <div style={{ height: 20 }} />
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", justifyContent: "center" }}>
            {differentiators.map((d, i) => (
              <div key={i} style={{
                flex: "1 1 240px", maxWidth: 280,
                background: "#fff", borderRadius: 18,
                border: `2px solid ${d.color}25`,
                padding: "18px 18px",
              }}>
                <div style={{
                  width: 8, height: 8, borderRadius: "50%",
                  background: d.color, marginBottom: 8,
                }} />
                <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>{d.title}</div>
                <div style={{ fontFamily: body, fontSize: 12.5, color: C.ink + "88", lineHeight: 1.5 }}>{d.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Credentials strip */}
      <section style={{ padding: "32px 24px" }}>
        <div style={{
          maxWidth: 700, margin: "0 auto",
          display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center",
        }}>
          {[
            { label: "Fully insured", sub: "Public liability cover", color: C.mint },
            { label: "DBS checked", sub: "All staff vetted", color: C.blue },
            { label: "All equipment provided", sub: "Nothing for you to arrange", color: C.yellow },
            { label: "Flexible scheduling", sub: "We fit around your timetable", color: C.pink },
          ].map((c, i) => (
            <div key={i} style={{
              flex: "1 1 140px", maxWidth: 160,
              background: "#fff", borderRadius: 16,
              border: `2px solid ${c.color}30`,
              padding: "16px 14px", textAlign: "center",
            }}>
              <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 13, color: C.ink, marginBottom: 4 }}>{c.label}</div>
              <div style={{ fontFamily: body, fontSize: 11, color: C.ink + "77" }}>{c.sub}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Reviews */}
      <section style={{ padding: "20px 24px 40px" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <RainbowHeading size={20} tag="h3">What parents are saying</RainbowHeading>
          <div style={{ height: 20 }} />
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            {[
              { quote: "Full of fun and energy which is perfect for my lively two year old! Sophie and Brittany put lots of thought into the sessions and the children really engage and enjoy it!", name: "Chantelle", sub: "Parent, regular classes" },
              { quote: "My little girl loved it and is asking to go back already! They have put so much effort in for the children and are both really engaging with the kids!", name: "Liz", sub: "Parent, regular classes" },
            ].map((r, i) => (
              <div key={i} style={{
                flex: "1 1 260px",
                background: "#fff", borderRadius: 20,
                border: `2px solid ${C.blue}20`,
                padding: "22px 20px",
              }}>
                <div style={{ fontFamily: body, fontSize: 13.5, color: C.ink + "99", lineHeight: 1.7, marginBottom: 14, fontStyle: "italic" }}>
                  "{r.quote}"
                </div>
                <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 13, color: C.ink }}>{r.name}</div>
                <div style={{ fontFamily: body, fontSize: 11, color: C.ink + "66" }}>{r.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Enquiry form */}
      <section id="enquire-section" style={{ padding: "0 24px 64px" }}>
        <div style={{ maxWidth: 580, margin: "0 auto" }}>
          {!submitted ? (
            <div style={{
              background: "#fff", borderRadius: 28,
              border: `2px solid ${C.blue}25`,
              padding: "36px 32px",
              animation: showForm ? "fadeIn 0.4s ease" : "none",
            }}>
              <RainbowHeading size={22} tag="h3">Get in touch</RainbowHeading>
              <p style={{
                fontFamily: body, fontSize: 13, color: C.ink + "88",
                textAlign: "center", margin: "8px 0 24px", lineHeight: 1.6,
              }}>
                Tell us a bit about your school and what you are looking for. We will get back to you within 24 hours to discuss availability and arrange a visit.
              </p>

              {/* School details */}
              <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10 }}>
                School or nursery details
              </div>
              <input type="text" placeholder="School or nursery name *" value={schoolName}
                onChange={e => setSchoolName(e.target.value)} style={inputStyle} />
              <input type="text" placeholder="Town or area" value={yearGroups}
                onChange={e => setYearGroups(e.target.value)} style={inputStyle} />

              {/* Contact details */}
              <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10, marginTop: 8 }}>
                Your details
              </div>
              <input type="text" placeholder="Your name *" value={contactName}
                onChange={e => setContactName(e.target.value)} style={inputStyle} />
              <input type="text" placeholder="Your role (e.g. Class Teacher, Head of EYFS)" value={role}
                onChange={e => setRole(e.target.value)} style={inputStyle} />
              <input type="email" placeholder="Email address *" value={email}
                onChange={e => setEmail(e.target.value)} style={inputStyle} />
              <input type="tel" placeholder="Phone number" value={phone}
                onChange={e => setPhone(e.target.value)} style={inputStyle} />

              {/* Session details */}
              <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10, marginTop: 8 }}>
                What are you interested in?
              </div>
              <select value={sessionInterest} onChange={e => setSessionInterest(e.target.value)}
                style={{ ...inputStyle, appearance: "none" }}>
                <option value="">Select session type *</option>
                <option value="Weekly sessions">Weekly dance sessions (ongoing)</option>
                <option value="Enrichment days">Workshops or enrichment days (one-off or short block)</option>
                <option value="Both">Both — I would like to discuss options</option>
              </select>
              <input type="text" placeholder="Year groups or age range (e.g. EYFS, KS1)" value={approxChildren}
                onChange={e => setApproxChildren(e.target.value)} style={inputStyle} />
              <input type="text" placeholder="Preferred days (e.g. Monday mornings, any day)" value={preferredDays}
                onChange={e => setPreferredDays(e.target.value)} style={inputStyle} />
              <textarea placeholder="Anything else you would like us to know?" value={notes}
                onChange={e => setNotes(e.target.value)}
                style={{ ...inputStyle, minHeight: 80, resize: "vertical" }} />

              {formError && (
                <div style={{
                  background: C.pinkSoft, borderRadius: 10, padding: "10px 14px",
                  fontFamily: body, fontSize: 13, color: C.pink, marginBottom: 14,
                }}>{formError}</div>
              )}

              <button
                onClick={handleSubmit}
                disabled={submitting}
                style={{
                  width: "100%",
                  background: submitting ? C.blue + "88" : C.blue,
                  color: "#fff", border: "none",
                  padding: "16px", borderRadius: 50,
                  fontFamily: heading, fontWeight: 700, fontSize: 16,
                  cursor: submitting ? "not-allowed" : "pointer",
                }}
              >
                {submitting ? "Sending..." : "Send Enquiry"}
              </button>
              <div style={{
                textAlign: "center", marginTop: 10,
                fontFamily: body, fontSize: 11, color: C.ink + "55",
              }}>
                We will get back to you within 24 hours
              </div>
            </div>
          ) : (
            <div style={{
              background: "#fff", borderRadius: 28,
              border: `2px solid ${C.mint}30`,
              padding: "48px 32px", textAlign: "center",
              animation: "fadeIn 0.4s ease",
            }}>
              <div style={{
                width: 56, height: 56, borderRadius: "50%",
                background: C.mintSoft, margin: "0 auto 16px",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontFamily: heading, fontSize: 26,
              }}>
                ✓
              </div>
              <RainbowHeading size={22} tag="h3">Enquiry received!</RainbowHeading>
              <p style={{ fontFamily: body, fontSize: 14, color: C.ink + "88", marginTop: 12, lineHeight: 1.6 }}>
                Thanks for getting in touch, {contactName.split(" ")[0]}. We will be in touch within 24 hours to discuss how we can bring The Funky Bunch to {schoolName}.
              </p>
              <button
                onClick={() => { window.location.hash = "home"; }}
                style={{
                  background: C.mint, color: "#fff", border: "none",
                  padding: "13px 28px", borderRadius: 50, marginTop: 24,
                  fontFamily: heading, fontWeight: 700, fontSize: 14,
                  cursor: "pointer",
                }}
              >
                Back to Home
              </button>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
